import { useCallback, useEffect, useMemo } from 'react';
//import { useNavigate } from 'react-router-dom';
import { useFetchWebsiteIndexEntriesQuery } from '../service';
import useUrlState from '../../../hooks/useUrlState';


export default function useGetCurrentWebsite() {
    //const navigate = useNavigate();
    const [urlState, setUrlState] = useUrlState();
    const { w_guid: websiteGuid } = urlState;
    const { data: websiteIndexEntries, isFetching: isFetchingWebsiteIndexEntries, isLoading: isLoadingWebsiteIndexEntries, isError } = useFetchWebsiteIndexEntriesQuery();
    const website = useMemo(() => websiteIndexEntries?.find((websiteIndexEntry) => websiteIndexEntry.guid === websiteGuid), [websiteGuid, websiteIndexEntries]);

    const setSelectedWebsite = useCallback(
        (websiteGuid: string) => {
            setUrlState({ w_guid: websiteGuid });
        },
        [setUrlState]
    );

    useEffect(() => {
        if (!websiteGuid && websiteIndexEntries && !isFetchingWebsiteIndexEntries) {
            if (websiteIndexEntries.length > 0) {
                const firstWebsite = websiteIndexEntries[0];
                setUrlState({ w_guid: firstWebsite.guid });
            }
            // } else {

            //     //TODO: check where is this hook used and if we need to make this redirect
            //     navigate('/deep-analysis/setup-domain')

            // }
        }

    }, [websiteIndexEntries, websiteGuid, isFetchingWebsiteIndexEntries, setUrlState]);

    return { website, setSelectedWebsite, websiteIndexEntries, isLoading: isLoadingWebsiteIndexEntries, isError };
}
